import {
  appendBranchIdForContributionBranch,
  removeBranchIdForContributionBranch,
} from "components/EditorTitle/utils";
import { useEnvironmentInterface } from "environment-interface";
import { useBranchEditor, useEditorFeature } from "features/editor/Feature";

import { slugifyBranchName } from "utils/git";

import type { Command } from "../../types";

export const useToggleRenamePaletteCommand = (): Command => {
  const { id, branch, contribution } = useBranchEditor();
  const [, dispatchEditor] = useEditorFeature();
  const { monacoEditor } = useEnvironmentInterface();

  const command: Command = {
    id: "codesandbox.git.renameBranch",
    section: "Git",
    name: "Rename Current Branch...",
    perform: async () => {
      const api = await monacoEditor.getExtensionApi();

      const result = await api.window.showInputBox({
        title: "Choose New Branch Name",
        value: removeBranchIdForContributionBranch(id, branch, contribution),
      });
      if (!result) {
        return;
      }

      dispatchEditor({
        type: "RENAME_BRANCH",
        newName: appendBranchIdForContributionBranch(
          id,
          slugifyBranchName(result),
          contribution,
        ),
      });
    },
  };

  return command;
};
